import liede from "./index.vue";
import liedeHome from "./Home.vue";

const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/liedeIndex",
    name: "liedeIndex",
    component: liedeHome
  },
  {
    path: "/liede/login",
    name: "liedeLogin",
    component: login
  },
  {
    path: "/liede",
    name: "liede",
    redirect: "/liede",
    component: liede,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
